import { clientWithCredentials } from '../_helpers';
import { alertConstants, ordersConstants } from '../_constants';
import { get as getCookie } from 'es-cookie';

export const ordersAction = {
    loadOrders
}

function loadOrders() {
    return function(dispatch: any){
        dispatch({
            type: ordersConstants.ORDERS_LOADING
        });
        // console.log(getCookie("token"));
        clientWithCredentials(dispatch).get(`api/order/all`)
        .then((data)=>{
            dispatch({
                type: ordersConstants.ORDERS_LOADED,
                data: data.data
            });
        })
        .catch((error)=>{
            dispatch({
                type: ordersConstants.ORDERS_ERROR,
            });
            dispatch({
                type: alertConstants.ALERT_SHOW,
                notification: {
                    message: error.message,
                    level: "error"
                }
            })
        })
    }
}